import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { SearchbarComponent } from '@shared-modules/table-shared/_components/searchbar/searchbar.component';
import { AdditionalFilters, TextValue } from '@shared/interfaces';
import { StatusFiltersMultiSelectComponent } from '../status-filters-multi-select/status-filters-multi-select.component';
import { StatusFiltersSingleSelectComponent } from '../status-filters-single-select/status-filters-single-select.component';

@Component({
    selector: 'app-composed-searchbar',
    standalone: true,
    imports: [
        TranslateModule,
        SearchbarComponent,
        StatusFiltersMultiSelectComponent,
        StatusFiltersSingleSelectComponent,
    ],
    templateUrl: './composed-searchbar.component.html',
    styleUrls: ['./composed-searchbar.component.scss'],
})
export class ComposedSearchbarComponent<T extends number | number[]> implements OnChanges {
    @Input({ required: true }) id: string = '';
    @Input({ required: true }) statusesList: TextValue[] = [];
    @Input({ required: true }) searchValue: string = '';
    @Input({ required: true }) selectedStatuses!: T;
    @Input() searchPlaceholder: string = 'searchByPlaceholder';
    @Input() additionalFilters: AdditionalFilters[] = [];

    @Output() selectedStatusesChange: EventEmitter<T> = new EventEmitter<T>();
    @Output() searchValueChange: EventEmitter<string> = new EventEmitter<string>();
    @Output() additionalFilterValueChange: EventEmitter<AdditionalFilters> = new EventEmitter<AdditionalFilters>();

    isMultiselect: boolean = false;

    updateStatus(newSelection: number | number[]) {
        this.selectedStatusesChange.emit(newSelection as T);
    }

    ngOnChanges(): void {
        if (Array.isArray(this.selectedStatuses)) this.isMultiselect = true;
        else this.isMultiselect = false;
    }
}
